<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Chapter-Title-Page-Break--Body-" id="_idParaDest-2"><a id="_idTextAnchor001"></a>PART THE FIRST.</p>
<p class="ORIM-Blockquote-Body--Body-">     It is an ancient Mariner,</p>
<p class="ORIM-Blockquote-Body--Body-">     And he stoppeth one of three.</p>
<p class="ORIM-Blockquote-Body--Body-">     “By thy long grey beard and glittering eye,</p>
<p class="ORIM-Blockquote-Body--Body-">     Now wherefore stopp’st thou me?</p>
<p class="ORIM-Blockquote-Body--Body-">     “The Bridegroom’s doors are opened wide,</p>
<p class="ORIM-Blockquote-Body--Body-">     And I am next of kin;</p>
<p class="ORIM-Blockquote-Body--Body-">     The guests are met, the feast is set:</p>
<p class="ORIM-Blockquote-Body--Body-">     May’st hear the merry din.”</p>
<p class="ORIM-Blockquote-Body--Body-">     He holds him with his skinny hand,</p>
<p class="ORIM-Blockquote-Body--Body-">     “There was a ship,” quoth he.</p>
<p class="ORIM-Blockquote-Body--Body-">     “Hold off! unhand me, grey-beard loon!”</p>
<p class="ORIM-Blockquote-Body--Body-">     Eftsoons his hand dropt he.</p>
<p class="ORIM-Blockquote-Body--Body-">     He holds him with his glittering eye—</p>
<p class="ORIM-Blockquote-Body--Body-">     The Wedding-Guest stood still,</p>
<p class="ORIM-Blockquote-Body--Body-">     And listens like a three years child:</p>
<p class="ORIM-Blockquote-Body--Body-">     The Mariner hath his will.</p>
<p class="ORIM-Blockquote-Body--Body-">     The Wedding-Guest sat on a stone:</p>
<p class="ORIM-Blockquote-Body--Body-">     He cannot chuse but hear;</p>
<p class="ORIM-Blockquote-Body--Body-">     And thus spake on that ancient man,</p>
<p class="ORIM-Blockquote-Body--Body-">     The bright-eyed Mariner.</p>
<p class="ORIM-Blockquote-Body--Body-">     The ship was cheered, the harbour cleared,</p>
<p class="ORIM-Blockquote-Body--Body-">     Merrily did we drop</p>
<p class="ORIM-Blockquote-Body--Body-">     Below the kirk, below the hill,</p>
<p class="ORIM-Blockquote-Body--Body-">     Below the light-house top.</p>
<p class="ORIM-Blockquote-Body--Body-">     The Sun came up upon the left,</p>
<p class="ORIM-Blockquote-Body--Body-">     Out of the sea came he!</p>
<p class="ORIM-Blockquote-Body--Body-">     And he shone bright, and on the right</p>
<p class="ORIM-Blockquote-Body--Body-">     Went down into the sea.</p>
<p class="ORIM-Blockquote-Body--Body-">     Higher and higher every day,</p>
<p class="ORIM-Blockquote-Body--Body-">     Till over the mast at noon—</p>
<p class="ORIM-Blockquote-Body--Body-">     The Wedding-Guest here beat his breast,</p>
<p class="ORIM-Blockquote-Body--Body-">     For he heard the loud bassoon.</p>
<p class="ORIM-Blockquote-Body--Body-">     The bride hath paced into the hall,</p>
<p class="ORIM-Blockquote-Body--Body-">     Red as a rose is she;</p>
<p class="ORIM-Blockquote-Body--Body-">     Nodding their heads before her goes</p>
<p class="ORIM-Blockquote-Body--Body-">     The merry minstrelsy.</p>
<p class="ORIM-Blockquote-Body--Body-">     The Wedding-Guest he beat his breast,</p>
<p class="ORIM-Blockquote-Body--Body-">     Yet he cannot chuse but hear;</p>
<p class="ORIM-Blockquote-Body--Body-">     And thus spake on that ancient man,</p>
<p class="ORIM-Blockquote-Body--Body-">     The bright-eyed Mariner.</p>
<p class="ORIM-Blockquote-Body--Body-">     And now the STORM-BLAST came, and he</p>
<p class="ORIM-Blockquote-Body--Body-">     Was tyrannous and strong:</p>
<p class="ORIM-Blockquote-Body--Body-">     He struck with his o’ertaking wings,</p>
<p class="ORIM-Blockquote-Body--Body-">     And chased south along.</p>
<p class="ORIM-Blockquote-Body--Body-">     With sloping masts and dipping prow,</p>
<p class="ORIM-Blockquote-Body--Body-">     As who pursued with yell and blow</p>
<p class="ORIM-Blockquote-Body--Body-">     Still treads the shadow of his foe</p>
<p class="ORIM-Blockquote-Body--Body-">     And forward bends his head,</p>
<p class="ORIM-Blockquote-Body--Body-">     The ship drove fast, loud roared the blast,</p>
<p class="ORIM-Blockquote-Body--Body-">     And southward aye we fled.</p>
<p class="ORIM-Blockquote-Body--Body-">     And now there came both mist and snow,</p>
<p class="ORIM-Blockquote-Body--Body-">     And it grew wondrous cold:</p>
<p class="ORIM-Blockquote-Body--Body-">     And ice, mast-high, came floating by,</p>
<p class="ORIM-Blockquote-Body--Body-">     As green as emerald.</p>
<p class="ORIM-Blockquote-Body--Body-">     And through the drifts the snowy clifts</p>
<p class="ORIM-Blockquote-Body--Body-">     Did send a dismal sheen:</p>
<p class="ORIM-Blockquote-Body--Body-">     Nor shapes of men nor beasts we ken—</p>
<p class="ORIM-Blockquote-Body--Body-">     The ice was all between.</p>
<p class="ORIM-Blockquote-Body--Body-">     The ice was here, the ice was there,</p>
<p class="ORIM-Blockquote-Body--Body-">     The ice was all around:</p>
<p class="ORIM-Blockquote-Body--Body-">     It cracked and growled, and roared and howled,</p>
<p class="ORIM-Blockquote-Body--Body-">     Like noises in a swound!</p>
<p class="ORIM-Blockquote-Body--Body-">     At length did cross an Albatross:</p>
<p class="ORIM-Blockquote-Body--Body-">     Thorough the fog it came;</p>
<p class="ORIM-Blockquote-Body--Body-">     As if it had been a Christian soul,</p>
<p class="ORIM-Blockquote-Body--Body-">     We hailed it in God’s name.</p>
<p class="ORIM-Blockquote-Body--Body-">     It ate the food it ne’er had eat,</p>
<p class="ORIM-Blockquote-Body--Body-">     And round and round it flew.</p>
<p class="ORIM-Blockquote-Body--Body-">     The ice did split with a thunder-fit;</p>
<p class="ORIM-Blockquote-Body--Body-">     The helmsman steered us through!</p>
<p class="ORIM-Blockquote-Body--Body-">     And a good south wind sprung up behind;</p>
<p class="ORIM-Blockquote-Body--Body-">     The Albatross did follow,</p>
<p class="ORIM-Blockquote-Body--Body-">     And every day, for food or play,</p>
<p class="ORIM-Blockquote-Body--Body-">     Came to the mariners’ hollo!</p>
<p class="ORIM-Blockquote-Body--Body-">     In mist or cloud, on mast or shroud,</p>
<p class="ORIM-Blockquote-Body--Body-">     It perched for vespers nine;</p>
<p class="ORIM-Blockquote-Body--Body-">     Whiles all the night, through fog-smoke white,</p>
<p class="ORIM-Blockquote-Body--Body-">     Glimmered the white Moon-shine.</p>
<p class="ORIM-Blockquote-Body--Body-">     “God save thee, ancient Mariner!</p>
<p class="ORIM-Blockquote-Body--Body-">     From the fiends, that plague thee thus!—</p>
<p class="ORIM-Blockquote-Body--Body-">     Why look’st thou so?”—With my cross-bow</p>
<p class="ORIM-Blockquote-Body--Body-">     I shot the ALBATROSS.</p>
<p class="Normal ParaOverride-2"><span class="CharOverride-2"><br/><br/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1-10.vue?280505bb